import PageNotFoundComponent from './PageNotFoundComponent/index';
import { withRouter } from 'react-router';


const PageNotFound = withRouter(PageNotFoundComponent)

export default PageNotFound;